function useSplitArray(initialArr) {
  const arr = initialArr;
  const length = arr.length
  const isEven = (length % 2 === 0);
  
  const first = arr.slice(0, Math.round(length/2))
  
  const second = isEven ? arr.slice(length/2, length) : arr.slice(length/2 + 1, length)

  const result = [first, second]

  return result;
}

export default useSplitArray;